import {useEffect, useState} from 'react'
import type {NoticePopup} from "../../lib/ModelTypes.ts";
import Cookies from "js-cookie";
import {useTranslation} from "react-i18next";
import {parseMultilingualMarkdown} from "../../util/MarkdownParser.ts";

interface PopupProps {
    popup: NoticePopup;
}

const Popup = ({popup}: PopupProps) => {
    const {t} = useTranslation();
    const {i18n} = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const [contentHtml, setContentHtml] = useState("");
    useEffect(() => {
        const isHidden = Cookies.get(`hidePopup_${popup.id}`);
        if (!isHidden) setIsVisible(true);
    }, [popup]);

    useEffect(() => {
        async function renderPopupContent() {
            const html = await parseMultilingualMarkdown(popup.content ?? "", i18n.language);
            setContentHtml(html);
        }

        renderPopupContent().finally();
    }, [popup.content, i18n.language]);

    const handleClose = (dontShowToday: boolean) => {
        setIsVisible(false);
        if (dontShowToday) {
            Cookies.set(`hidePopup_${popup.id}`, "true", {expires: 1});
        }
    };

    if (!isVisible) return null;

    return (
        <div
            className="popup-container"
            style={{
                top: `${popup.x}px`,
                left: `${popup.y}px`,
                zIndex: 1100 - (popup.order ?? 0)
            }}
        >
            <div
                className="h-100"
                style={{
                    minWidth: `${popup.width}px`,
                    minHeight: `${popup.height}px`,
                    padding: '10px',
                    borderBottom: `1px solid #cdd2d7`,
                }}
                // dangerouslySetInnerHTML={{__html: popup.content!}}
                dangerouslySetInnerHTML={{__html: contentHtml}}
            />
            <div className="d-grid" style={{gridTemplateColumns: 'repeat(2, 1fr)'}}>
                <button className="popup-button" onClick={() => handleClose(true)}
                        style={{borderRight: '1px solid #cdd2d7'}}>
                    {t("popup.inactiveToday")}
                </button>

                <button className="popup-button" onClick={() => handleClose(false)}>
                    {t("popup.close")}
                </button>
            </div>
        </div>
    );
};

export default Popup;